import React, {useEffect} from "react";
import {withRouter} from "react-router-dom";
import {inject} from "mobx-react";
import {Box, Button, CircularProgress, withStyles} from "@material-ui/core";
import {uniqBy, sortBy} from "lodash";
import clsx from "clsx";
import {toast} from "react-toastify";

import {styles} from "./styles";
import AxlAutocomplete from "../../components/AxlAutocomplete";
import {getListClients, switchClient, updateClientId} from "../../stores/api";
import {LoadingOverlay} from "../../components/LoadingOverlay";
import AxlDialog from "../../components/AxlDialog";

function SwitchClient({classes, history, userStore}) {
  const {user, client} = userStore;
  const [loading, setLoading] = React.useState(false);
  const [showConfirm, setShowConfirm] = React.useState(false);
  const [clients, setClients] = React.useState([]);
  const [selectedClient, setSelectedClient] = React.useState(null);
  const [switching, setSwitching] = React.useState(false);

  useEffect(() => {
    setLoading(true);
    getListClients().then(response => {
      if (response.ok && response.data) {
        const clientList = sortBy(
          uniqBy(response.data, d => d.client_id),
          d => d.name
        ).map(d => ({
          label: d.name,
          value: d.client_id,
        }));

        const selected = clientList.find(c => c.value === user.externalId);

        setSelectedClient(selected);
        setClients(clientList);
      } else {
        setClients([]);
      }
      setLoading(false);
    })
  }, []);

  function goBack() {
    history.push("/");
  }

  function handleCloseDialog() {
    if (switching) {
      return;
    }

    setShowConfirm(false);
  }

  function handleChangeClient(selected) {
    setSelectedClient(selected);
  }

  function handleSwitchClient() {
    if (switching || !selectedClient?.value)
      return;

    setSwitching(true);
    updateClientId(selectedClient.value).then(response => {
      if (response.ok) {
        switchClient(selectedClient.value).then(res => {
          if (res.ok) {
            window.location.href = "/";
          } else {
            toast.error(res.data.message || 'Failed to switch client');
          }
          setSwitching(false);
        });
      } else {
        setSwitching(false);
        toast.error(response.data.message || 'Failed to switch client');
      }
    })
  }

  return (
    <Box className={clsx({[classes.wrapper]: true, [classes.container]: true})}>
      {loading && <LoadingOverlay />}
      <Box align="left" component="h3" className={classes.headerTitle}>Select Different Client</Box>
      <Box mb={2}>
        <Box component="h3" className={classes.inputLabel}>Current Client</Box>
        <Box ml={1.5}>[{client?.id}] {client?.company}</Box>
      </Box>
      <Box mb={2}>
        <Box component="h3" className={classes.inputLabel}>Switch To</Box>
        <AxlAutocomplete
          options={clients}
          onChange={(_, selected) => handleChangeClient(selected)}
          value={selectedClient}
          getOptionLabel={(option) => `[${option.value}] ${option.label}`}
          getOptionSelected={(opt, val) => opt.value === val.value}
        />
      </Box>
      <Box align="right" mt={3}>
        <Button disabled={switching} onClick={goBack} variant="outlined" color="primary" disableElevation className={classes.button}>
          Cancel
        </Button>
        <Button disabled={switching || selectedClient?.value === user.externalId}
                onClick={() => setShowConfirm(true)}
                variant="contained"
                disableElevation
                color="primary"
                className={classes.button}
        >
          Save
        </Button>
      </Box>

      <AxlDialog isOpen={showConfirm}
                 handleClose={handleCloseDialog}
                 childrenTitle="Confirmation"
                 childrenAction={(
                   <Box>
                     <Button disabled={switching}
                             onClick={handleCloseDialog}
                             variant="outlined"
                             color="primary"
                             disableElevation
                             className={classes.button}
                     >
                       Cancel
                     </Button>
                     <Button disabled={switching || selectedClient?.value === user.externalId}
                             onClick={handleSwitchClient}
                             variant="contained"
                             disableElevation
                             color="primary"
                             className={classes.button}
                     >
                       {!switching ? 'Switch' : <CircularProgress color="inherit" size={24} />}
                     </Button>
                   </Box>
                 )}
      >
        <Box align="center" fontSize="1.2em">
          Are you sure to switch to client <strong>{selectedClient?.label}</strong> ?
        </Box>
      </AxlDialog>
    </Box>
  )
}

export default withStyles(styles)(withRouter(inject('userStore')(SwitchClient)));